import { ComputedRef } from "vue";

export function useDuplicateNameGenerator(names: ComputedRef<string[]>) {
	const namesSet = computed(() => new Set(names.value));

	function generate(name: string): string {
		let i = 1;
		let generatedName = name;

		while (namesSet.value.has(generatedName)) {
			generatedName = `${name} (${i})`;
			i++;
		}

		return generatedName;
	}

	return { generate };
}
